import React from 'react';
import ProposalStatusLayout from 'components/common/proposal/ProposalStatusLayout';
import Form from 'components/web-form/Form';
import RenewalFormHeader from 'components/web-form/RenewalFormHeader';
import { createStyles } from '../../globalStyles';

const RenewalFormPage = (): JSX.Element => {
  const classes = createStyles();
  return (
    <ProposalStatusLayout>
      <div className={classes.pageWrapper}>
        <RenewalFormHeader />
        <Form type="RENEWAL" />
      </div>
    </ProposalStatusLayout>
  );
};

export default RenewalFormPage;
